import ApplicationController from "./application_controller";

/* This is the custom StimulusReflex controller for the Posts Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {

  static targets = ["preview", "input"];
  static values = {
    paletteid: Number,
    objtype: String,
    objid: Number
  };

  connect() {
  }

  async changedTitle(event) {
    const response = await this.doFetch(
      "/style/",
      "PATCH",
      JSON.stringify({
        authenticity_token: document.querySelector('meta[name="csrf-token"]')
          .content,
        title: event.target.value,
        paletteid: this.element.dataset.stylepaletteseditorPaletteidValue,
      }),
    );
    return true;
  }
  async changedProperty(event) {
    this.previewTarget.style[event.target.dataset["cssproperty"]] =
    event.target.value;

    console.log("changedProperty " + event.target.dataset["cssproperty"]);
    const response = await this.doFetch(
      "/style/",
      "PATCH",
      JSON.stringify({
        authenticity_token: document.querySelector('meta[name="csrf-token"]')
          .content,
        styleruleid: event.target.dataset["styleruleId"],
        cssproperty: event.target.dataset["cssproperty"],
        cssvalue: event.target.value,
        paletteid: this.element.dataset.stylepaletteseditorPaletteidValue,
      }),
    );
    this.reloadStylesheet();
    return true;
  }

  reloadStylesheet() {
    const link = document.querySelector(this.stylesheetLinkId());
    link.href = link.href.replace(/\?.*|$/, "?" + Date.now());
    console.log(`reloadStylesheet ${link.href}`);
  }

  stylesheetLinkId() {
    return `#${this.objtypeValue.toLowerCase()}_${this.objidValue}-stylesheet`;
  }
}
